
import * as React from 'react';
import configData from "../config.json";

import { RouteComponentProps } from 'react-router';
import {
    Card, CardHeader, CardBody, Row, Col, FormGroup,
    Label, Input, InputGroup, InputGroupAddon, Button
} from 'reactstrap';

import { alertService } from 'components/Varios/alert_service.js';
import SelectItem from "components/Varios/select.js";
import Datepicker from "components/Varios/Datepicker.js";
import CardInformacionAcademica from "components/Varios/CardInformacionAcademica.js";

//import FileUpload from "components/Varios/FileUpload.js";
//import FileDownload from "components/Varios/FileDownload.js";

import InputFileDownload from "components/Varios/InputFileDownload.js";
import InputFileUpload from "components/Varios/InputFileUpload.js";

import { authenticationService } from '../services/authentication.service';
import { InfoFetchTitulos, InformacionSenescytTitulos } from './Datos Personales/Informacion Academica/TypesInformacionAcademica';
import ModalTitulosRegistradosSenescyt from './Datos Personales/Informacion Academica/ModalTitulosRegistradosSenescyt';
import { SelectCombo } from './Types/GeneralTypes';
import EmptyInputMessage from './Varios/EmptyInputMessage';
import axios from 'axios';
import { authHeaderWithUserData } from 'helpers/auth-header';

// const id = 1043;
const API_URL = configData.SERVER_URL

const ID_NIVEL_EDUCACION_TERCER_NIVEL = 13;
const ID_NIVEL_EDUCACION_TECNICO_SUPERIOR = 15;
const ID_NIVEL_EDUCACION_CUARTO_NIVEL = 3;

const NIVELES_EDUCACION_SUPERIOR_NUMBER: number[] = [
    ID_NIVEL_EDUCACION_TERCER_NIVEL,
    ID_NIVEL_EDUCACION_TECNICO_SUPERIOR,
    ID_NIVEL_EDUCACION_CUARTO_NIVEL
]

const NIVELES_EDUCACION_SUPERIOR_STRING: string[] = [
    ID_NIVEL_EDUCACION_TERCER_NIVEL.toString(),
    ID_NIVEL_EDUCACION_TECNICO_SUPERIOR.toString(),
    ID_NIVEL_EDUCACION_CUARTO_NIVEL.toString()
]

export enum NivelGradoAPI {
    TERCER_NIVEL = "TERCER NIVEL",
    CUARTO_NIVEL = "CUARTO NIVEL",
    TECNICO_SUPERIOR = "TECNICO SUPERIOR"
}

export function ParseNivelesEducacionName(nivel: string | number) {
    var nivel_normalized = nivel.toString();
    var nombre = ""
    switch (nivel_normalized) {
        case ID_NIVEL_EDUCACION_TERCER_NIVEL.toString():
            nombre = NivelGradoAPI.TERCER_NIVEL
            break;
        case ID_NIVEL_EDUCACION_CUARTO_NIVEL.toString():
            nombre = NivelGradoAPI.CUARTO_NIVEL
            break;
        case ID_NIVEL_EDUCACION_TECNICO_SUPERIOR.toString():
            nombre = NivelGradoAPI.TERCER_NIVEL
            break;
        default:
            break;
    }
    return nombre;
}


export class InformacionAcademicaData {
    ideducacionformal: number = 0;
    idpersona: number = 0;

    nivel: string = "";
    niveltitulo: number = 0;
    idinstitucion: number = 0;
    idtituloacademico: number = 0;
    estado: string = "";

    idpais: number = 0;
    strcampoamplio?: string = "";
    strcampoespecifico?: string = "";
    strcampodetallado?: string = "";

    institucion: string = "";

    idnomenclaturatit: number = 0;

    tituloobtenido: string = "";
    fechagraduacion: string = "";
    tituloobtenidosenescyt: string = "";
    codsenescyt: string = "";
    fechasenescyt?: string = "";

    idareafrascati: number = 0;
    idsubareafrascati: number = 0;
    convalidado: string = "N"

    refarchivo: string = "";
    namearchdoc2: string = "";
    namearchdoc3: string = "";
}


interface InformacionAcademicaDataState {
    currentUser: any,
    loading: boolean,
    loadingList: boolean,
    dtoData: InformacionAcademicaData,
    InformacionAcademicaDataList: InformacionAcademicaData[],
    paisList: Array<any>,
    nivelInstruccionList: Array<any>,
    gradoList: Array<any>,
    institucionList: Array<any>,
    areaCINEList: Array<any>,
    subAreaCINEList: Array<any>,
    materiaCINEList: Array<any>,
    areaFrascatiList: Array<any>,
    subAreaFrascatiList: Array<any>,
    error: null,
    tiposEvidencia: Array<any>,
    filesData: Array<any>,
    informacionModalTitulos: InfoFetchTitulos,
    showModalTitulos: boolean,
    activateEmptyMessage: boolean,
    estadonivelInstruccionList: Array<any>
}


type FilesInfoAcademica = {
    type: string, 
    file: File, 
    id: string, 
    src: string
}
export class DatosGenerales extends React.Component<RouteComponentProps<{}>, InformacionAcademicaDataState> {

    constructor(props) {
        super(props);



        this.state = {
            currentUser: authenticationService.currentUserValue,
            loading: true,
            loadingList: true,
            dtoData: new InformacionAcademicaData(),
            InformacionAcademicaDataList: [],
            paisList: [],
            nivelInstruccionList: [],
            gradoList: [],
            institucionList: [],
            areaCINEList: [],
            subAreaCINEList: [],
            materiaCINEList: [],
            areaFrascatiList: [],
            subAreaFrascatiList: [],
            error: null,
            tiposEvidencia: [],
            filesData: [],
            informacionModalTitulos: {
                nivel: ""
            },
            showModalTitulos: false,
            activateEmptyMessage: false,
            estadonivelInstruccionList: []
        };

        this.cargarDatos = this.cargarDatos.bind(this);
        this.cargarInformacionAcademica = this.cargarInformacionAcademica.bind(this);
        this.cargarGrados = this.cargarGrados.bind(this);
        this.cargarInstituciones = this.cargarInstituciones.bind(this);
        this.cargarSubAreaCINE = this.cargarSubAreaCINE.bind(this);
        this.cargarMaterias = this.cargarMaterias.bind(this);
        this.cargarSubAreaFrascati = this.cargarSubAreaFrascati.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.handleSelectChangeInstitucion = this.handleSelectChangeInstitucion.bind(this);
        this.handleFileUploadChange = this.handleFileUploadChange.bind(this);
        this.llenarFormulario = this.llenarFormulario.bind(this);
        this.mostrarSeccionFormularioNivelInstruccion = this.mostrarSeccionFormularioNivelInstruccion.bind(this);
        this.mostrarSeccionFormularioSenescyt = this.mostrarSeccionFormularioSenescyt.bind(this);
        this.VerificarExisteReferenciaArchivo = this.VerificarExisteReferenciaArchivo.bind(this);
        this.handleSelectChangeEstadonivelInstruccion = this.handleSelectChangeEstadonivelInstruccion.bind(this);
    }


    componentDidMount() {
        authenticationService.currentUser.subscribe(
            (x) => {
                this.setState({
                    currentUser: x
                });
                if (x && x.token) {
                    this.cargarDatos();
                    this.cargarInformacionAcademica();
                }
            }
        );
    }

    componentWillUnmount() {
        alertService.clear();
    }

    cargarDatos() {
        //API PARA OBTENER PAISES
        fetch(API_URL + "DatosEscalafon/Paises")
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        this.setState({
                            paisList: result.entTabla.map(d => ({
                                "value": d.idpais,
                                "label": d.nombre
                            })),
                        });
                    } else {
                        //console.log(result["strMensaje"])
                        alertService.error("Ocurrió un error al obtener los países.")
                    }
                },
                (error) => {

                    this.setState({
                        loading: false,
                        error,
                        paisList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )

        // API PARA OBTENER NIVEL DE INSTRUCCIÓN
        fetch(API_URL + "InformacionFamiliar/NivelInstruccion")
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        this.setState({
                            nivelInstruccionList: result.entTabla.map(d => ({
                                "value": String(d.codigo),
                                "label": d.descripcion
                            })),
                        });
                    } else {
                        //console.log(result["strMensaje"])
                        alertService.error("Ocurrió un error al obtener los niveles de instrucción.")
                    }
                },
                (error) => {

                    this.setState({
                        loading: false,
                        error,
                        nivelInstruccionList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )

        // API PARA OBTENER AREAS DE CONOCMIENTO CINE
        fetch(API_URL + "InformacionAcademica/InformacionAcademicaCampoAmplio/0/0/0/00")
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {

                        this.setState({
                            areaCINEList: result.entTabla.map(d => ({
                                "value": d.campoamplio,
                                "label": d.nombrecampoa
                            })),
                        });
                    } else {
                        //console.log(result["strMensaje"])
                        alertService.error("Ocurrió un error al obtener las áreas de conocimiento CINE.")
                    }
                },
                (error) => {

                    this.setState({
                        loading: false,
                        error,
                        areaCINEList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )

        // API PARA OBTENER AREAS FRASCATI
        fetch(API_URL + "InformacionAcademica/InformacionAcademicaCatalogo/AREA FRASCATI")
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        this.setState({
                            areaFrascatiList: result.entTabla.map(d => ({
                                "value": d.codigo,
                                "label": d.descripcion
                            })),
                        });
                    } else {
                        //console.log(result["strMensaje"])
                        alertService.error("Ocurrió un error al obtener las áreas FRASCATI.")
                    }
                },
                (error) => {

                    this.setState({
                        loading: false,
                        error,
                        nivelInstruccionList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )

        // API PARA OBTENER ESTADO NIVEL INSTRUCCIÓN
        fetch(API_URL + "InformacionAcademica/InformacionAcademicaCatalogo/ESTADO NIVEL INSTRUCCIÓN")
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        this.setState({
                            estadonivelInstruccionList: result.entTabla.map(d => ({
                                "value": d.codigostr.trim(),
                                "label": d.descripcion
                            })),
                        });
                    } else {
                        alertService.error("Ocurrió un error al obtener ESTADO NIVEL INSTRUCCIÓN.")
                    }
                },
                (error) => {

                    this.setState({
                        loading: false,
                        error,
                        estadonivelInstruccionList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )
    }

    //API PARA OBTENER INFORMACIÓN ACADÉMICA DE PERSONA
    cargarInformacionAcademica() {
        fetch(API_URL + "InformacionAcademica/InformacionAcademicaByIdPersonaDesc/" + this.state.currentUser.idpersona)
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        this.setState({
                            InformacionAcademicaDataList: result.entTabla,
                            loading: false,
                            loadingList: false
                        });
                    } else {
                        //console.log(result["strMensaje"])
                        alertService.error("Ocurrió un error al obtener la información académica.")
                    }
                },
                (error) => {

                    this.setState({
                        loading: false,
                        error,
                        InformacionAcademicaDataList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )
    }

    async cargarInstituciones(idPais) {
        var OpcionesInstituciones: SelectCombo[] = [];

        var dto = this.state.dtoData;
        dto['idpais'] = idPais;
        this.setState({
            dtoData: dto,
            tiposEvidencia: this.cargarEvidencias(Number(dto.nivel), dto.idpais)
        });

        const a = await fetch(API_URL + "InformacionAcademica/InstitucionByIdPais/" + idPais)
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {

                        result.entTabla.map((d) => {
                            OpcionesInstituciones.push({
                                "value": d.idinstitucion,
                                "label": d.nombre
                            })
                        })

                        this.setState({
                            institucionList: OpcionesInstituciones
                        });

                    } else {
                        alertService.error("Ocurrió un error al obtener las instituciones.")
                    }
                },
                (error) => {

                    this.setState({
                        loading: false,
                        error,
                        institucionList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )
        return OpcionesInstituciones;

    }

    cargarSubAreaFrascati(idcatalogopadre, change = true) {
        var dto = this.state.dtoData;
        dto["idareafrascati"] = idcatalogopadre;
        if (change) {
            dto['idsubareafrascati'] = 0;
        }

        this.setState({ dtoData: dto });

        fetch(API_URL + "InformacionAcademica/InformacionAcademicaCatalogoSubAreaFrascatiByCodigo/" + idcatalogopadre)
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {

                        this.setState({
                            subAreaFrascatiList: result.entTabla.map(d => ({
                                "value": d.codigo,
                                "label": d.descripcion
                            })),
                        });
                    } else {
                        //console.log(result["strMensaje"])
                        alertService.error("Ocurrió un error al obtener las subáreas FRASCATI.")
                    }
                },
                (error) => {

                    this.setState({
                        loading: false,
                        error,
                        subAreaFrascatiList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )
    }

    cargarSubAreaCINE(strcampoamplio, change = true) {
        var dto = this.state.dtoData;
        dto["strcampoamplio"] = strcampoamplio;
        if (change) {
            dto['strcampoespecifico'] = "";
            dto['strcampodetallado'] = "";
        }

        this.setState({ dtoData: dto });

        fetch(API_URL + "InformacionAcademica/InformacionAcademicaCampoEspecifico/0/0/00/" + strcampoamplio)
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        this.setState({
                            subAreaCINEList: result.entTabla.map(d => ({
                                "value": d.campoespecifico,
                                "label": d.nombrecampoe
                            })),
                        });
                    } else {
                        //console.log(result["strMensaje"])
                        alertService.error("Ocurrió un error al obtener las subáreas CINE.")
                    }
                },
                (error) => {

                    this.setState({
                        loading: false,
                        error,
                        subAreaCINEList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )
    }

    cargarMaterias(strcampoespecifico, change = true) {
        var dto = this.state.dtoData;
        dto["strcampoespecifico"] = strcampoespecifico;
        if (change) {
            dto['strcampodetallado'] = "";
        }

        this.setState({ dtoData: dto });

        fetch(API_URL + "InformacionAcademica/InformacionAcademicaCampoDetallado/0/00/" + dto.strcampoamplio + "/" + strcampoespecifico)
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {

                        this.setState({
                            materiaCINEList: result.entTabla.map(d => ({
                                "value": d.idnomenclaturatit,
                                "label": d.nombrecampod
                            })),
                        });
                    } else {
                        //console.log(result["strMensaje"])
                        alertService.error("Ocurrió un error al obtener las materias CINE.")
                    }
                },
                (error) => {

                    this.setState({
                        loading: false,
                        error,
                        materiaCINEList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )
    }

    obtenerGradosSegunNivel = async (niveltrim: string) => {

        var respuestaMetodo: { listaRespuesta: any[], error: boolean, mensajeError?: string } = {
            error: false,
            listaRespuesta: []
        }
        const rutaApiGrado = ParseNivelesEducacionName(niveltrim);

        if (rutaApiGrado) {
            const rutaConsulta = `${API_URL}InformacionAcademica/InformacionAcademicaCatalogo/${rutaApiGrado}`;
            try {
                const respuesta = await axios.get(rutaConsulta, {
                    headers: authHeaderWithUserData(authenticationService.currentUserValue)
                })

                respuestaMetodo = {
                    error: false,
                    listaRespuesta: respuesta.data.entTabla
                }

            } catch (error) {
                if (axios.isAxiosError(error) && error.response !== undefined) {
                    respuestaMetodo = { ...respuestaMetodo, error: true, mensajeError: error.response.data };
                } else {
                    respuestaMetodo = { ...respuestaMetodo, error: true }
                }
            }
        }

        return respuestaMetodo;

    }

    async cargarGrados(nivel, edicion: boolean) {

        //VALOR 3 ES POSTGRADO-CUARTO NIVEL , VALOR 13 ES TERCER NIVEL , VALOR 15 ES TECNICO SUPERIOR


        var nivelTrim: string = nivel.trim();

        var dto = this.state.dtoData;



        dto['nivel'] = nivel;
        this.setState({
            dtoData: dto,
            tiposEvidencia: this.cargarEvidencias(Number(dto.nivel), dto.idpais)
        });

        if (nivel.trim() === "3") {
            fetch(API_URL + "InformacionAcademica/InformacionAcademicaCatalogo/CUARTO NIVEL")
                .then(res => res.json())
                .then(
                    (result) => {
                        if (result.strEstado === "S") {
                            this.setState({
                                gradoList: result.entTabla.map(d => ({
                                    "value": d.codigo,
                                    "label": d.descripcion
                                })),
                            });
                        } else {
                            //console.log(result["strMensaje"])
                            alertService.error("Ocurrió un error al obtener los grados.")
                        }
                    },
                    (error) => {

                        this.setState({
                            loading: false,
                            error,
                            gradoList: []
                        });
                        alertService.error("Ocurrió un error: " + error)
                    }
                )

        }
        else if (nivel.trim() === "13") {
            fetch(API_URL + "InformacionAcademica/InformacionAcademicaCatalogo/TERCER NIVEL")
                .then(res => res.json())
                .then(
                    (result) => {
                        if (result.strEstado === "S") {

                            this.setState({
                                gradoList: result.entTabla.map(d => ({
                                    "value": d.codigo,
                                    "label": d.descripcion
                                })),
                            });
                        } else {
                            //console.log(result["strMensaje"])
                            alertService.error("Ocurrió un error al obtener los grados.")
                        }
                    },
                    (error) => {

                        this.setState({
                            loading: false,
                            error,
                            gradoList: []
                        });
                        alertService.error("Ocurrió un error: " + error)
                    }
                )
        }
        else {
            const respuestaMetodoGrados = await this.obtenerGradosSegunNivel(nivelTrim);
            if (respuestaMetodoGrados.listaRespuesta.length > 0) {
                this.setState({
                    gradoList: respuestaMetodoGrados.listaRespuesta.map(d => ({
                        "value": d.codigo,
                        "label": d.descripcion
                    })),
                });
            }
            else if (respuestaMetodoGrados.error) {
                this.setState({
                    loading: false,
                    gradoList: []
                });
                alertService.error("Ocurrió un error: " + (respuestaMetodoGrados.mensajeError ?? "Ha ocurrido un error al intentar obtener las opciones "))
            }
        }
        

        if (NIVELES_EDUCACION_SUPERIOR_STRING.find((value) => value === nivelTrim) && (typeof (edicion) === "string" || edicion == false)) {

            this.setState({

                informacionModalTitulos: {
                    nivel: ParseNivelesEducacionName(nivelTrim)
                },
                showModalTitulos: true
            })
        }


    }

    handleChange(event) {
        var dto = this.state.dtoData;
        dto[event.target.name] = event.target.value;
        this.setState({
            dtoData: dto,
            loading: false
        })
    }

    handleSelectChangeInstitucion(value, name, tipo = null, label) {
        var dto = this.state.dtoData;
        dto[name] = value;
        dto['institucion'] = label;
        this.setState({ dtoData: dto });

    }

    handleSelectChange(value, name) {
        var dto = this.state.dtoData;
        dto[name] = value;

        if (name === "idnomenclaturatit") {
            dto["strcampodetallado"] = value;
        }

        var tiposEvidencia;
        if (name === "nivel") {
            tiposEvidencia = this.cargarEvidencias(Number(value), dto.idpais);
        } else if (name === "pais") {
            tiposEvidencia = this.cargarEvidencias(Number(dto.nivel), Number(value));
        } else {
            tiposEvidencia = this.cargarEvidencias(Number(dto.nivel), dto.idpais);
        }

        this.setState({
            dtoData: dto,
            tiposEvidencia: tiposEvidencia
        });
    }

    handleSelectChangeEstadonivelInstruccion(value, name) {
        var dto = this.state.dtoData;
        dto[name] = value;
        dto['fechagraduacion'] = "";
        this.setState({ dtoData: dto });

    }

    handleFileUploadChange(tipoEvidencia, uploadFile) {
        const src = window.URL.createObjectURL(uploadFile);
        const fileInfo = { type: tipoEvidencia, file: uploadFile, id: tipoEvidencia, src: src };
        let fileInfoState = this.state.filesData.slice();
        let fileInfoStateFiltrado = fileInfoState.filter(f => f.type !== fileInfo.type);
        fileInfoState = fileInfoStateFiltrado.concat(fileInfo);
        //console.log(fileInfoState)
        this.setState({
            filesData: fileInfoState,
        });

    }

    cargarEvidencias(idnivel = 0, idpais = 0) {
        //console.log("idnivel=" + idnivel + " idpais=" + idpais);
        var tiposEvidencia = [
            { "value": "TIT", "label": "Título" }
        ];
        if ((idnivel === 15 || idnivel === 3 || idnivel === 13)) {
            tiposEvidencia = tiposEvidencia.concat([
                { "value": "SEN", "label": "Registro SENESCYT" }
            ]);
        }
        if (idpais !== 1) {
            tiposEvidencia = tiposEvidencia.concat([
                { "value": "APO", "label": "Doc. Apostillado" }
            ]);
        }
        return tiposEvidencia;
    }

    descargarEvidencias(infoAcademica: InformacionAcademicaData) {
        var evidencias = new Array();
        if (infoAcademica.refarchivo) {
            evidencias.push({ name: "TIT" + infoAcademica.idpersona + ".PDF", url: API_URL + "InformacionAcademica/Refarchivo/TIT/" + infoAcademica.ideducacionformal });
        }
        if (infoAcademica.namearchdoc2) {
            evidencias.push({ name: "APO" + infoAcademica.idpersona + ".PDF", url: API_URL + "InformacionAcademica/Refarchivo/APO/" + infoAcademica.ideducacionformal });
        }
        if (infoAcademica.namearchdoc3) {
            evidencias.push({ name: "SEN" + infoAcademica.idpersona + ".PDF", url: API_URL + "InformacionAcademica/Refarchivo/SEN/" + infoAcademica.ideducacionformal });
        }
        return evidencias;
    }

    onClickLimpiar() {
        this.setState({ dtoData: new InformacionAcademicaData(), activateEmptyMessage: false });
    }

    onClickEdit(ideducacionformal) {
        this.setState({
            dtoData: new InformacionAcademicaData()
        });
        //API PARA OBTENER TELEFONOS DE PERSONA
        fetch(API_URL + "InformacionAcademica/InformacionAcademicaByIdDesc/" + ideducacionformal)
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {

                        this.setState({
                            dtoData: result.entTabla[0],
                            tiposEvidencia: this.cargarEvidencias(result.entTabla[0].nivel, result.entTabla[0].idpais),
                            loading: false
                        });


                        if (result.entTabla[0]["nivel"].trim() === "3") {
                             this.cargarGrados("3", true)
                        }
                        else if (result.entTabla[0]["nivel"].trim() === "13") {
                            this.cargarGrados("13", true)
                        }


                        if (result.entTabla[0]["idpais"]) {
                            this.cargarInstituciones(result.entTabla[0]["idpais"])
                        }

                        if (result.entTabla[0]["strcampoamplio"]) {

                            this.cargarSubAreaCINE(result.entTabla[0]["strcampoamplio"], false)
                        }

                        if (result.entTabla[0]["strcampoespecifico"]) {
                            this.cargarMaterias(result.entTabla[0]["strcampoespecifico"], false)
                        }

                        if (result.entTabla[0]["idareafrascati"]) {
                            this.cargarSubAreaFrascati(result.entTabla[0]["idareafrascati"], false)
                        }

                        let myDiv = document.getElementById('main-panel')!;
                        myDiv.scrollTo(0, 0);

                    } else {
                        alertService.error(result["strMensaje"])
                    }

                },
                (error) => {

                    this.setState({
                        loading: false,
                        error,
                        dtoData: new InformacionAcademicaData()
                    });
                    alertService.error("Ocurrió un error")
                }
            )
    }

    onClickDelete(ideducacionformal) {
        fetch(API_URL + "FormularioController/DeleteDatosInformacionAcademica/" + ideducacionformal, {

            method: 'DELETE',
            headers: { 'Content-Type': 'application/json' },

        })
            .then(response => response.json())
            .then(
                (responseJson) => {
                    if (responseJson["strEstado"] === "N") {
                        alertService.error(responseJson["strMensaje"])
                    }
                    else {
                        alertService.success("La información académica se eliminó correctamente.")
                        this.cargarInformacionAcademica();
                    }
                })
    }


    mostrarSeccionFormularioSenescyt() {
        return (
            <React.Fragment>
                
            </React.Fragment>
        )
    }

    mostrarSeccionFormularioNivelInstruccion(paisList: Array<any>, nivelInstruccionList: Array<any>,
        gradoList: Array<any>, institucionList: Array<any>
        , tiposEvidencia: Array<any>, estadonivelInstruccionList: Array<any>) {
        return (
            <React.Fragment>
                <p style={{ color: "#FFC200" }}>NIVEL DE INSTRUCCIÓN</p>
                <Row form>
                    {/* <Col md={3}>
                        <FormGroup>
                            <Label for="nivel">Instrucción*</Label>
                            <SelectItem
                                options={nivelInstruccionList}
                                value={this.state.dtoData.nivel.trim()}
                                onChange={this.cargarGrados}
                                placeholder=""
                                name="nivel"
                                id="nivel"
                                icon="nivel_instruccion"
                            />
                        </FormGroup>
                    </Col> */}
                    {['13', '3', '15'].includes(String(this.state.dtoData.nivel.trim())) ?

                        <Col md={2}>
                            <FormGroup>
                                <Label for="idpais">Grado del Título*</Label>
                                <SelectItem
                                    options={gradoList}
                                    value={this.state.dtoData.niveltitulo}
                                    onChange={this.handleSelectChange}
                                    placeholder=""
                                    name="niveltitulo"
                                    id="niveltitulo"
                                    icon="fa-caret-right"
                                />
                                <EmptyInputMessage activate={this.state.activateEmptyMessage} data={this.state.dtoData.niveltitulo} />

                            </FormGroup>
                        </Col>
                        : null}

                    <Col md={3}>
                        <FormGroup>
                            <Label for="idpais">País*</Label>
                            <SelectItem
                                options={paisList}
                                value={this.state.dtoData.idpais}
                                onChange={this.cargarInstituciones}
                                placeholder="Seleccione País"
                                name="idpais"
                                id="idpais"
                                icon="pais"
                                disabledHover={true}
                            />
                            <EmptyInputMessage activate={this.state.activateEmptyMessage} data={this.state.dtoData.idpais} />
                        </FormGroup>
                    </Col>

                    {(NIVELES_EDUCACION_SUPERIOR_STRING.includes(String(this.state.dtoData.nivel.trim())) && this.state.dtoData.idpais === 1) ?
                        <Col md={4}>
                            <FormGroup>
                                <Label for="idpais">Nombre de la institución que emite*</Label>
                                <SelectItem
                                    options={institucionList}
                                    value={this.state.dtoData.idinstitucion}
                                    onChange={this.handleSelectChangeInstitucion}
                                    placeholder="Seleccione nombre de institución"
                                    name="idinstitucion"
                                    id="idinstitucion"
                                    icon="fa-caret-right"
                                />
                                <EmptyInputMessage activate={this.state.activateEmptyMessage} data={this.state.dtoData.idinstitucion} />

                            </FormGroup>
                        </Col>
                        : null}
                    {(!NIVELES_EDUCACION_SUPERIOR_STRING.includes(String(this.state.dtoData.nivel.trim())) || this.state.dtoData.idpais !== 1) ?
                        <Col md={(NIVELES_EDUCACION_SUPERIOR_STRING.includes(String(this.state.dtoData.nivel.trim())) ? 4 : 6)}>
                            <FormGroup>
                                <Label for="institucion">Nombre de la institución que emite*</Label>
                                <Input className="input-written" maxLength="250" name="institucion" id="institucion" value={this.state.dtoData.institucion} onChange={this.handleChange} required />
                                <EmptyInputMessage activate={this.state.activateEmptyMessage} data={this.state.dtoData.institucion} />
                            </FormGroup>
                        </Col>
                        : null}
                </Row>
                <Row form>
                    <Col md={4}>
                        <FormGroup>
                            <Label for="tituloobtenido">Nombre del Título{this.state.dtoData.nivel.trim() !== "8" ? "*" : ""}</Label>
                            <Input className="input-written" maxLength="200" name="tituloobtenido" id="tituloobtenido" value={this.state.dtoData.tituloobtenido} onChange={this.handleChange} required={this.state.dtoData.nivel.trim() !== "8" ? true : false} />

                        </FormGroup>
                    </Col>
                    <Col md={2}>
                        <FormGroup>
                            <Label for="nivel">Estado Nivel Instrucción*</Label>
                            <SelectItem
                                options={estadonivelInstruccionList}
                                value={this.state.dtoData.estado.trim()}
                                onChange={this.handleSelectChangeEstadonivelInstruccion}
                                placeholder="Seleccione"
                                name="estado"
                                id="estado"
                                icon="nivel_instruccion"
                                disabledHover={true}
                            />
                            <EmptyInputMessage data={this.state.dtoData.estado} activate={this.state.activateEmptyMessage} />

                        </FormGroup>
                    </Col>
                    <Col md={2}>
                        <FormGroup>
                            <Label for="fechagraduacion">Fecha de graduación*</Label>
                            <Datepicker
                                value={this.state.dtoData.fechagraduacion}
                                name="fechagraduacion"
                                id="fechagraduacion"
                                disabled={this.state.dtoData.estado.trim() !== "GR"}
                                onChange={this.handleSelectChange}
                            />
                            <EmptyInputMessage activate={this.state.activateEmptyMessage} data={this.state.dtoData.estado === "GR" || this.state.dtoData.estado === "" ? this.state.dtoData.fechagraduacion : " "} />

                        </FormGroup>
                    </Col>
                    <Col md={4}>
                        <Label for="fechagraduacion">Evidencia*</Label>
                        <FormGroup row>
                            <Col md={(this.descargarEvidencias(this.state.dtoData).length > 0 ? 10 : 12)}>
                                <InputFileUpload
                                    icon="upload"
                                    onChange={this.handleFileUploadChange}
                                    name="TIT"
                                    placeholder={this.state.dtoData.refarchivo ? "Actualizar título" : "Subir título"}
                                    required={true}
                                />
                            </Col>
                            <InputFileDownload tipo="título"
                                id="downloadRef"
                                refarchivo={this.state.dtoData.refarchivo}
                                name={"TIT" + this.state.dtoData.idpersona + ".PDF"}
                                url={API_URL + "InformacionAcademica/Refarchivo/TIT/" + this.state.dtoData.ideducacionformal}
                            />
                        </FormGroup>
                    </Col>
                    {
                        //NIVELES_EDUCACION_SUPERIOR_STRING.includes(String(this.state.dtoData.nivel.trim())) && this.state.dtoData.idpais === 1 ?
                        //    <Col md={3}>
                        //        <Label for="fechagraduacion">Evidencia*</Label>
                        //        <FormGroup row>
                        //            <Col md={(this.descargarEvidencias(this.state.dtoData).length > 0 ? 10 : 12)}>
                        //                <InputFileUpload
                        //                    icon="upload"
                        //                    onChange={this.handleFileUploadChange}
                        //                    name="SEN"
                        //                    placeholder={this.state.dtoData.namearchdoc3 ? "Actualizar Registro SENESCYT" : "Subir Registro SENESCYT"} />
                        //            </Col>
                        //            <InputFileDownload tipo="registro SENESCYT"
                        //                id="downloadRef3"
                        //                refarchivo={this.state.dtoData.namearchdoc3}
                        //                name={"SEN" + this.state.dtoData.idpersona + ".PDF"}
                        //                url={API_URL + "InformacionAcademica/Refarchivo/SEN/" + this.state.dtoData.ideducacionformal}
                        //            />
                        //        </FormGroup>
                        //    </Col>
                        //    : NIVELES_EDUCACION_SUPERIOR_STRING.includes(String(this.state.dtoData.nivel.trim())) && this.state.dtoData.idpais !== 1 ?
                        //        <Col md={3}>
                        //            <Label for="fechagraduacion">Evidencia</Label>
                        //            <FormGroup row>
                        //                <Col md={(this.descargarEvidencias(this.state.dtoData).length > 0 ? 10 : 12)}>
                        //                    <InputFileUpload
                        //                        icon="upload"
                        //                        onChange={this.handleFileUploadChange}
                        //                        name="SEN"
                        //                        placeholder={this.state.dtoData.namearchdoc3 ? "Actualizar Registro SENESCYT" : "Subir Registro SENESCYT"} />
                        //                </Col>
                        //                <InputFileDownload tipo="registro SENESCYT"
                        //                    id="downloadRef3"
                        //                    refarchivo={this.state.dtoData.namearchdoc3}
                        //                    name={"SEN" + this.state.dtoData.idpersona + ".PDF"}
                        //                    url={API_URL + "InformacionAcademica/Refarchivo/SEN/" + this.state.dtoData.ideducacionformal}
                        //                />
                        //            </FormGroup>
                        //        </Col>
                        //        :
                        //        null
                    }
                    {
                        //this.state.dtoData.idpais !== 1 && this.state.dtoData.idpais !== 0 ?
                        //    <Col md={3}>
                        //        <Label for="fechagraduacion">Evidencia*</Label>
                        //        <FormGroup row>
                        //            <Col md={(this.descargarEvidencias(this.state.dtoData).length > 0 ? 10 : 12)}>
                        //                <InputFileUpload
                        //                    icon="upload"
                        //                    onChange={this.handleFileUploadChange}
                        //                    name="APO"
                        //                    placeholder={this.state.dtoData.namearchdoc2 ? "Actualizar doc. apostillado" : "Subir doc. apostillado"} />
                        //            </Col>
                        //            <InputFileDownload tipo="doc. apostillado"
                        //                id="downloadRef2"
                        //                refarchivo={this.state.dtoData.namearchdoc2}
                        //                name={"APO" + this.state.dtoData.idpersona + ".PDF"}
                        //                url={API_URL + "InformacionAcademica/Refarchivo/APO/" + this.state.dtoData.ideducacionformal}
                        //            />
                        //        </FormGroup>
                        //    </Col>
                        //    :
                        //    null
                    }
                </Row>
            </React.Fragment>
        )
    }


    async llenarFormulario(informacionTitulo: InformacionSenescytTitulos) {
        //tipoTiulo es NACIONALIDAD
        //ies  es el Nombre de la Universidad
        alertService.newWarn("No olvide completar la información necesaria y guardar sus cambios")


        var InformacionFormulario = this.state.dtoData;

        const OPCIONES_TIPOTITULO = ["NACIONALES,EXTRANJEROS"]
        const { tipoTitulo, ies, fechaGrado } = informacionTitulo;

        var codigoPaisUsar: number;
        var nombreInstitucion = ies;
        var fechaGraduacionSenescyt = fechaGrado;


        InformacionFormulario["codsenescyt"] = informacionTitulo.numeroRegistro
        InformacionFormulario["tituloobtenido"] = informacionTitulo.nombreTitulo
        InformacionFormulario["tituloobtenidosenescyt"] = informacionTitulo.nombreTitulo
        InformacionFormulario["fechasenescyt"] = informacionTitulo.fechaRegistro.toString()

        if (fechaGraduacionSenescyt) {
            InformacionFormulario["fechagraduacion"] = fechaGraduacionSenescyt.toString()
        }

        if (tipoTitulo && tipoTitulo === "NACIONALES") {
            codigoPaisUsar = 1; //Codigo 1 es ECUADOR

            InformacionFormulario["idpais"] = codigoPaisUsar;
            var OpcionesInstituciones = await this.cargarInstituciones(1);

            if (nombreInstitucion && OpcionesInstituciones) {

                var valueInstitucion = OpcionesInstituciones.find((valueOpciones) => {
                    return valueOpciones.label === nombreInstitucion
                })

                if (valueInstitucion) {
                    InformacionFormulario["idinstitucion"] = +valueInstitucion.value
                    InformacionFormulario["institucion"] = valueInstitucion.label
                }
            }
        }
        else {
            InformacionFormulario["idpais"] = 0
            InformacionFormulario["idinstitucion"] = 0
        }

        this.setState({
            dtoData: InformacionFormulario,
            informacionModalTitulos: {
                nivel: ""
            },
            activateEmptyMessage: true
        })



    }


    VerificarExisteReferenciaArchivo(EvidenciasUsuarioDebeSubir: SelectCombo[], InformacionAcademica: InformacionAcademicaData, filesData:Array<FilesInfoAcademica>) {
        //refarchivo -  titulo      namearchdoc2 - apostillado  , namearchdoc3 - registro Titulo
        var namesEvidencias = {
            "TIT": "refarchivo",
            "APO": "namearchdoc2",
            "SEN": "namearchdoc3"
        };
        var puedeGuardar: boolean = true;
        for (let index = 0; index < EvidenciasUsuarioDebeSubir.length; index++) {

            var valueEvidencia = EvidenciasUsuarioDebeSubir[index].value
            var nombrePropiedadEvidencia = namesEvidencias[valueEvidencia]

            var valorFileDataLocal = filesData.find(c => c.id === valueEvidencia);

            if (InformacionAcademica[nombrePropiedadEvidencia] === "" && (valorFileDataLocal === null || valorFileDataLocal === undefined || valorFileDataLocal.id === "")) {
                puedeGuardar = false;
            }

        }
        return puedeGuardar;
    }


    private handleSave(event) {

        //type PropType<TObj, TProp extends keyof TObj> = TObj[TProp];  

        event.preventDefault();


        const forma = new FormData(event.target);
        var dto = this.state.dtoData;
        
        var filesData = this.state.filesData;
        var evidenciasUsuarioDebeSubir: SelectCombo[] = this.state.tiposEvidencia
        let formIsValid = true;
        let errors = "";

        //Si el pais no es Ecuador, entonces no es obligatorio subir el registro SENESCYT
        if (dto.idpais > 1) {
            evidenciasUsuarioDebeSubir = evidenciasUsuarioDebeSubir.filter((evidencia) => evidencia.value !== "SEN" );
        }

        var tieneTodasLasEvidencias =  this.VerificarExisteReferenciaArchivo(evidenciasUsuarioDebeSubir,dto,filesData) 

        if ((evidenciasUsuarioDebeSubir.length !== filesData.length) && !tieneTodasLasEvidencias ) {
            formIsValid = false;
            errors = "Por favor, suba toda la evidencia solicitada/obligatoria *";

        }

        forma.forEach((value, clave) => {
            if (!value && clave !== "evidencias") {

                if ((dto.nivel.trim() !== "8" && dto.nivel.trim() !== "14") && clave !== "codsenescyt") {
                    if (clave !== "tituloobtenidosenescyt" && clave !== "tituloobtenidosenescyt" && clave !== "fechasenescyt") {
                        formIsValid = false;
                        errors = "Por favor seleccione todos los campos. "
                    }

                }
                if (dto.nivel.trim() == "8" && clave !== "tituloobtenido") {
                    formIsValid = false;
                    errors = "Por favor seleccione todos los campos. "
                }
            }

            if (clave === "evidencia" && !value) {
                formIsValid = false;
                errors = "Por favor seleccione todos los campos. "
            }

            // if(!value) {
            //     formIsValid = false;
            //     errors = "Por favor complete todos los"
            // }

            if (clave === "codsenescyt" && value) {
                if (!(/[0-9-]+$/.test(String(value)))) {
                    formIsValid = false;
                    errors = "Escriba correctamente el Nº de registro."
                }
            }

            if (typeof dto[clave] === 'number') {
                dto[clave] = Number(value);
            }
            else if (typeof dto[clave] === 'boolean') {
                dto[clave] = Boolean(value);
            }
            else
                dto[clave] = value;

            if (clave === 'fechagraduacion' || clave === 'fechasenescyt') {
                value = String(value)
                var info = value.split('/').reverse().join('-');
                var date = new Date(String(info))
                dto[clave] = date.toJSON();
            }

            if (clave === "idnomenclaturatit") {
                dto["strcampodetallado"] = String(value);
            }
        });

        if (!['13', '3', '15'].includes(String(dto.nivel.trim()))) {
            delete dto['fechasenescyt'];
        }

        if (formIsValid) {
            delete dto['strcampoamplio'];
            delete dto['strcampoespecifico'];
            delete dto['strcampodetallado'];
            delete dto['strareacampoamplio'];
            delete dto['strareacampoespecifico'];
            delete dto['strareacampodetallado'];
            delete dto['strareafrascati'];
            delete dto['strsubareafrascati'];
        }

        dto.idpersona = this.state.currentUser.idpersona;

        const data = JSON.stringify({
            "teducacionformal": dto,
        });

        if (formIsValid) {
            if (dto.ideducacionformal === 0) {
                fetch(API_URL + "FormularioController/PostDatosInformacionAcademica", {

                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: data,

                })
                    .then(response => response.json())
                    .then(
                        (responseJson) => {
                            if (responseJson["strEstado"] === "N") {
                                alertService.error("Ocurrió un error: " + responseJson)
                            }
                            else {
                                alertService.success("La información académica se ha actualizado correctamente.")
                                authenticationService.updateUltimoCambioCurrentUserValue(new Date().toISOString())

                                if (filesData.length > 0) {
                                    var formFilesData = new FormData();

                                    filesData.map((fileData) => {
                                        formFilesData.append(fileData.type, fileData.file, fileData.file.name);
                                    });

                                    formFilesData.append('ideducacionformal', responseJson.teducacionformal.ideducacionformal);

                                    fetch(API_URL + "FormularioController/PostFilesDatosInformacionAcademica", {
                                        method: 'POST',
                                        body: formFilesData
                                    })
                                        .then(response => response.json())
                                        .then(success => {
                                            // Do something with the successful response
                                        })
                                        .catch(error => alertService.error(error) //console.log(error)
                                        );
                                }
                                this.cargarInformacionAcademica();
                                this.onClickLimpiar();
                            }

                        },
                        (error) => {
                            alertService.error("Ocurrió un error: " + error)
                        })
            }
            else {
                fetch(API_URL + "FormularioController/PutDatosInformacionAcademica", {

                    method: 'PUT',
                    headers: { 'Content-Type': 'application/json' },
                    body: data,

                })
                    .then(response => response.json())
                    .then(
                        (responseJson) => {
                            if (responseJson["strEstado"] === "N") {
                                alertService.error(responseJson["strMensaje"])

                            }
                            else {
                                alertService.success("La información académica se ha registrado correctamente.")
                                authenticationService.updateUltimoCambioCurrentUserValue(new Date().toISOString())

                                if (filesData.length > 0) {
                                    var formFilesData = new FormData();

                                    filesData.map((fileData) => {
                                        formFilesData.append(fileData.type, fileData.file, fileData.file.name);
                                    });

                                    formFilesData.append('ideducacionformal', responseJson.teducacionformal.ideducacionformal);

                                    fetch(API_URL + "FormularioController/PostFilesDatosInformacionAcademica", {
                                        method: 'POST',
                                        body: formFilesData
                                    })
                                        .then(response => response.json())
                                        .then(success => {
                                            // Do something with the successful response
                                        })
                                        .catch(error => alertService.error(error)//console.log(error)
                                        );
                                }
                                this.onClickLimpiar();
                                this.cargarInformacionAcademica();

                            }

                        }
                        , (error) => {
                            alertService.error("Ocurrió un error: " + error)
                        }
                    )


            }
        }
        else {
            this.setState({ activateEmptyMessage: true })
            alertService.error("Ocurrió un error: " + errors);
            window.scrollTo({
                top: 0,
                behavior: "auto"
            });
        }

    }




    public render() {

        let contents = this.state.loading

            ? <div style={{ textAlign: "center" }}>
                <i className="fas fa-sync fa-spin"></i>
                <em> Cargando</em>
            </div>

            : this.renderForm(this.state.InformacionAcademicaDataList, this.state.paisList, this.state.nivelInstruccionList, this.state.gradoList, this.state.institucionList,
                this.state.areaCINEList, this.state.subAreaCINEList, this.state.materiaCINEList, this.state.areaFrascatiList, this.state.subAreaFrascatiList, this.state.tiposEvidencia, this.state.estadonivelInstruccionList);
        return <div className="content">

            {contents}

        </div>;

    }

    private renderForm(InformacionAcademicaDataList: Array<any>, paisList: Array<any>, nivelInstruccionList: Array<any>, gradoList: Array<any>, institucionList: Array<any>,
        areaCINEList: Array<any>, subAreaCINEList: Array<any>, materiaCINEList: Array<any>, areaFrascatiList: Array<any>, subAreaFrascatiList: Array<any>, tiposEvidencia: Array<any>, estadonivelInstruccionList: Array<any>) {

        return (
            <>
                <Row>
                    <Col md={12} className="">
                        <Card className="principal">
                            <CardHeader>
                                <h5 className="title">INFORMACIÓN ACADÉMICA</h5>
                            </CardHeader>
                            <CardBody className="main-content ">
                                <div>
                                    <form onSubmit={this.handleSave} autoComplete='off'>

                                        <Row form>
                                            <Col md={3}>
                                                <FormGroup>
                                                    <Label for="nivel">Instrucción*</Label>
                                                    <SelectItem
                                                        options={nivelInstruccionList}
                                                        value={this.state.dtoData.nivel.trim()}
                                                        onChange={this.cargarGrados}
                                                        placeholder="Seleccione su nivel de Instrucción"
                                                        name="nivel"
                                                        id="nivel"
                                                        icon="nivel_instruccion"
                                                        disabledHover={true}
                                                    />
                                                    <EmptyInputMessage data={this.state.dtoData.nivel} activate={this.state.activateEmptyMessage} />

                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        {
                                            this.mostrarSeccionFormularioSenescyt()
                                        }
                                        {
                                            this.mostrarSeccionFormularioNivelInstruccion(paisList, nivelInstruccionList, gradoList, institucionList, tiposEvidencia, estadonivelInstruccionList)
                                        }


                                        {['13', '3', '15'].includes(String(this.state.dtoData.nivel.trim())) ?
                                            <Row form>
                                                <Col md={6}>
                                                    {/*<p style={{ color: "#FFC200" }}>ÁREA DE CONOCIMIENTO CINE</p>*/}
                                                    {/*<FormGroup row>*/}
                                                        {/*<Col md={4} className="">*/}
                                                        {/*    <Label for="idpais">Área de conocimiento <br /> CINE en función del título*</Label>*/}
                                                        {/*    <SelectItem*/}
                                                        {/*        options={areaCINEList}*/}
                                                        {/*        value={this.state.dtoData.strcampoamplio}*/}
                                                        {/*        onChange={this.cargarSubAreaCINE}*/}
                                                        {/*        placeholder=""*/}
                                                        {/*        name="strcampoamplio"*/}
                                                        {/*        id="strcampoamplio"*/}
                                                        {/*        icon="fa-caret-right"*/}
                                                        {/*    />*/}
                                                        {/*    <EmptyInputMessage data={this.state.dtoData.strcampoamplio} activate={this.state.activateEmptyMessage} />*/}

                                                        {/*</Col>*/}
                                                        {/*<Col md={4} className="">*/}
                                                        {/*    <Label for="strcampoespecifico">Sub-Área de  <br /> conocimiento CINE*</Label>*/}
                                                        {/*    <SelectItem*/}
                                                        {/*        options={subAreaCINEList}*/}
                                                        {/*        value={this.state.dtoData.strcampoespecifico}*/}
                                                        {/*        onChange={this.cargarMaterias}*/}
                                                        {/*        placeholder=""*/}
                                                        {/*        name="strcampoespecifico"*/}
                                                        {/*        id="strcampoespecifico"*/}
                                                        {/*        icon="fa-caret-right"*/}
                                                        {/*    />*/}
                                                        {/*    <EmptyInputMessage data={this.state.dtoData.strcampoespecifico} activate={this.state.activateEmptyMessage} />*/}
                                                        {/*</Col>*/}
                                                        {/*<Col md={4} className="">*/}
                                                        {/*    <Label for="strcampodetallado">Área de conocimiento <br /> (materias)*</Label>*/}
                                                        {/*    <SelectItem*/}
                                                        {/*        options={materiaCINEList}*/}
                                                        {/*        value={this.state.dtoData.idnomenclaturatit}*/}
                                                        {/*        onChange={this.handleSelectChange}*/}
                                                        {/*        placeholder=""*/}
                                                        {/*        name="idnomenclaturatit"*/}
                                                        {/*        id="strcampodetallado"*/}
                                                        {/*        icon="fa-caret-right"*/}
                                                        {/*    />*/}
                                                        {/*    <EmptyInputMessage data={this.state.dtoData.idnomenclaturatit} activate={this.state.activateEmptyMessage} />*/}
                                                        {/*</Col>*/}
                                                    {/*</FormGroup>*/}

                                                </Col>
                                                <Col md={6}>
                                                    {/*<p style={{ color: "#FFC200" }}>ÁREA DE CONOCIMIENTO FRASCATI</p>*/}
                                                    {/*<FormGroup row>*/}
                                                    {/*    <Col md={6} className="">*/}
                                                    {/*        <Label for="idpais">Área de conocimiento FRASCATI  <br /> en función del título*</Label>*/}
                                                    {/*        <SelectItem*/}
                                                    {/*            options={areaFrascatiList}*/}
                                                    {/*            value={this.state.dtoData.idareafrascati}*/}
                                                    {/*            onChange={this.cargarSubAreaFrascati}*/}
                                                    {/*            placeholder=""*/}
                                                    {/*            name="idareafrascati"*/}
                                                    {/*            id="idareafrascati"*/}
                                                    {/*            icon="fa-caret-right"*/}
                                                    {/*        />*/}
                                                    {/*        <EmptyInputMessage data={this.state.dtoData.idareafrascati} activate={this.state.activateEmptyMessage} />*/}
                                                    {/*    </Col>*/}
                                                    {/*    <Col md={6} className="">*/}
                                                    {/*        <Label for="idsubareafrascati">Sub-Área de conocimiento  <br /> FRASCATI*</Label>*/}
                                                    {/*        <SelectItem*/}
                                                    {/*            options={subAreaFrascatiList}*/}
                                                    {/*            value={this.state.dtoData.idsubareafrascati}*/}
                                                    {/*            onChange={this.handleSelectChange}*/}
                                                    {/*            placeholder=""*/}
                                                    {/*            name="idsubareafrascati"*/}
                                                    {/*            id="idsubareafrascati"*/}
                                                    {/*            icon="fa-caret-right"*/}
                                                    {/*        />*/}
                                                    {/*        <EmptyInputMessage data={this.state.dtoData.idsubareafrascati} activate={this.state.activateEmptyMessage} />*/}
                                                    {/*    </Col>*/}
                                                    {/*</FormGroup>*/}
                                                </Col>


                                            </Row>
                                            : null}

                                        <Row form>
                                            <Col md={12}>
                                                <FormGroup>
                                                    <Button color="primary" type="button" className="btn btn-default" style={{ float: "right" }} onClick={() => this.onClickLimpiar()}>Limpiar</Button>
                                                    <Button color="secondary" type="submit" className="btn btn-default" style={{ float: "right" }}>Guardar</Button>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </form>
                                </div>
                                <br />
                                <div>
                                    {(this.state.loadingList ?
                                        <div style={{ textAlign: "center" }}>
                                            <i className="fas fa-sync fa-spin"></i>
                                            <em> Cargando</em>
                                        </div>
                                        :
                                        <Row id="lista">
                                            {InformacionAcademicaDataList.map((dto, index) =>
                                                <CardInformacionAcademica

                                                    key={dto.ideducacionformal}
                                                    strNivelEstudio={dto.strNivelEstudio}
                                                    institucion={dto.institucion}
                                                    tituloobtenido={dto.tituloobtenido}
                                                    strNombrePais={dto.strNombrePais}
                                                    fechagraduacion={dto.fechagraduacion}
                                                    codsenescyt={dto.codsenescyt}
                                                    fechasenescyt={dto.fechasenescyt}
                                                    nivel={dto.nivel}
                                                    strareacampoamplio={dto.strareacampoamplio}
                                                    strareafrascati={dto.strareafrascati}
                                                    evidencias={this.descargarEvidencias(dto)}
                                                    number={(index + 1) + " / " + InformacionAcademicaDataList.length}
                                                    eventEdit={() => this.onClickEdit(dto.ideducacionformal)}
                                                    eventDelete={() => this.onClickDelete(dto.ideducacionformal)}
                                                />
                                            )}
                                        </Row>
                                    )}
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <ModalTitulosRegistradosSenescyt
                    fullscreen='lg'
                    size='lg'
                    informacion={this.state.informacionModalTitulos}
                    show={this.state.showModalTitulos}
                    onClose={() => this.setState({
                        showModalTitulos: false,
                        informacionModalTitulos: { nivel: "" }
                    })}
                    key="keyModalTitulosSenescyt"
                    handleRegistroSeleccionado={(tituloInfo) => { this.llenarFormulario(tituloInfo) }}
                    informacionGuardada={this.state.InformacionAcademicaDataList}

                />
            </>
        );
    }
}

export default DatosGenerales;